/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MigratedQuestMilestone
 */
export interface MigratedQuestMilestone {
    /**
     * 
     * @type {string}
     * @memberof MigratedQuestMilestone
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MigratedQuestMilestone
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MigratedQuestMilestone
     */
    sources: Array<string>;
}

/**
 * Check if a given object implements the MigratedQuestMilestone interface.
 */
export function instanceOfMigratedQuestMilestone(value: object): value is MigratedQuestMilestone {
    if (!('sources' in value) || value['sources'] === undefined) return false;
    return true;
}

export function MigratedQuestMilestoneFromJSON(json: any): MigratedQuestMilestone {
    return MigratedQuestMilestoneFromJSONTyped(json, false);
}

export function MigratedQuestMilestoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigratedQuestMilestone {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'sources': json['sources'],
    };
}

export function MigratedQuestMilestoneToJSON(json: any): MigratedQuestMilestone {
    return MigratedQuestMilestoneToJSONTyped(json, false);
}

export function MigratedQuestMilestoneToJSONTyped(value?: MigratedQuestMilestone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'sources': value['sources'],
    };
}

